<!-- 人才公寓 -->
<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="" prop="bcontent">
              <div style="border: 1px solid #ccc; box-sizing: border-box">
                <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                />
                <Editor
                  :style="`height: 550px; overflow-y: hidden;`"
                  :defaultConfig="editorConfig"
                  v-model="formData.bcontent"
                  @onCreated="onCreated"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="dialog-footer" style="text-align: right">
        <el-button
          :loading="btnLoading"
          type="primary"
          @click="onSubmit"
          size="default"
          >保存</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
import {
  QueryBlogDetailByCategory,
  UpdateBlogDetail,
  AddBlogDetail,
} from "@/api/ArticleContent/ArticleContent";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { uploadFile } from "@/api/upload/upload";
export default {
  components: { Editor, Toolbar },
  data() {
    return {
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {
        btitle: [{ required: true, message: "请输入标题", trigger: "blur" }],
        bRemark: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
      },
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let alt = file.name;
                let href = ``;
                insertFn(url, alt, href);
              } else {
                this.$message.error("图片上传失败");
              }
            },
          },
          uploadVideo: {
            async customUpload(file, insertFn) {
              let res = await uploadFile(file);
              if (res.status == 200) {
                let raw = res.response || {};
                let url = raw.Url;
                let poster = "";

                insertFn(url, poster);
              } else {
                this.$message.error("视频上传失败");
              }
            },
          },
        },
      },
    };
  },
  computed: {},
  mounted() {
    this.openDialog();
  },
  methods: {
    openDialog() {
      let e = { bcategory: 11 };
      let key = "edit";
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
      };
      this.title = dic[key];
      key == "edit" &&
        this.HttpQueryBlogDetail({ id: e.Id, bcategory: e.bcategory });
      key == "add" &&
        (this.formData = {
          btitle: "",
          bRemark: "",
          bcontent: "",
          EndTime: "",
          bcategory: 1,
        });
      console.log("this.formData==>", this.formData);
      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
      console.log(this.formData);
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes("image");
      const isLt4M = file.size / 1024 / 1024 < 10;
      console.log(file.type);
      if (!isImage) {
        this.$message.error("上传头像图片只能是图片格式!");
      }
      // if (!isLt4M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // return isImage && isLt4M;
      return isImage;
    },
    onSubmit() {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit();
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit() {
      let param = this.formData;

      this.key == "add" && this.HttpAddBlogDetail(param);
      this.key == "edit" && this.HttpUpdateBlogDetail(param);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    async HttpQueryBlogDetail(param) {
      this.isLoading = true;
      const response = await QueryBlogDetailByCategory(param);
      this.isLoading = false;
      let res = response.data;
      if (res.status == 200) {
        let raw = res.response || {};
        console.log("raw", raw);
        this.formData = raw;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUpdateBlogDetail(param) {
      this.btnLoading = true;
      const response = await UpdateBlogDetail(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddBlogDetail(param) {
      this.btnLoading = true;
      const response = await AddBlogDetail(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
